import { render, staticRenderFns } from "./DemergeStudy.vue?vue&type=template&id=bc375748"
import script from "./DemergeStudy.vue?vue&type=script&lang=js"
export * from "./DemergeStudy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports